import React from 'react';
import Image from 'next/image';
import { Avatar } from '@material-ui/core';
import clsx from 'clsx';
import { format } from 'date-fns';

import { formatPrice } from 'utils/helpers';
import NoAvatarImage from 'public/images/no-avatar.svg';
import styles from 'styles/components/WishOrderCard.module.scss';

const size = { width: 25, height: 25 };
const avatarFullSize = { width: '100%', height: '100%' };

const WishOrderCard = ({ order, userKey }) => {
  const { wish } = order;
  const user = order[userKey];

  return (
    <div className={clsx(styles.orderCard, { [styles.fullWidth]: userKey === 'influencer' })}>
      <div className={styles.imgContainer}>
        <Image src={wish.image_url} layout="fill" alt={wish.name} unoptimized />
      </div>

      <div className={styles.content}>
        <div className={styles.wishInfo}>
          <h3 style={{ marginBottom: 10 }}>{wish.name}</h3>

          {order.message && <p>{order.message}</p>}

          <span className={styles.date}>
            {format(new Date(order.created_at), 'MMM d, hh:mm a')}
          </span>
        </div>

        <div className={styles.userInfo}>
          <div style={{ display: 'flex' }}>
            <Avatar style={size} src={user.avatar_url}>
              <NoAvatarImage style={avatarFullSize} />
            </Avatar>

            <h4>{user.display_name}</h4>
          </div>

          <h3>{formatPrice(order.amount)}</h3>
        </div>
      </div>
    </div>
  );
};

export default WishOrderCard;
